import { render, staticRenderFns } from "./DetailCatatanKas.vue?vue&type=template&id=57b3f5f9&"
import script from "./DetailCatatanKas.vue?vue&type=script&lang=js&"
export * from "./DetailCatatanKas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports